import Swal, { SweetAlertOptions } from 'sweetalert2';
import { ModalOptions } from 'constants/models/sweetAlertTypes';

/**
 * @description Info Alert
 * @param title Alert 標題
 * @param html Alert 內容
 */
const info = (title: string, html?: string) => {
  return Swal.fire({
    icon: 'info',
    title,
    html,
    confirmButtonText: '確認'
  });
};

/**
 * @description Success Alert
 * @param title Alert 標題
 * @param html Alert 內容
 */
const success = (title: string, html?: string) => {
  return Swal.fire({
    icon: 'success',
    title,
    html,
    confirmButtonText: '確認'
  });
};

/**
 * @description Error Alert
 * @param title Alert 標題
 * @param html Alert 內容
 */
const error = (title: string, html?: string) => {
  return Swal.fire({
    icon: 'error',
    title,
    html,
    confirmButtonText: '確認'
  });
};

/**
 * @description Confirm Alert
 * @param title Alert 標題
 * @param html Alert 內容
 */
const confirm = (title: string, html?: string) => {
  return Swal.fire({
    icon: 'info',
    title,
    html,
    confirmButtonText: '確認',
    showCancelButton: true,
    cancelButtonText: '取消'
  });
};

/**
 * @description Modal
 * @param option 配置 Modal Options
 */
const modal = (option: ModalOptions) => {
  const config = {
    ...option,
    icon: option.icon ? 'info' : undefined,
    iconHtml: `<i class="modal__icon--${option.icon}">`
  };

  return Swal.fire({
    animation: false,
    closeButtonHtml: '',
    customClass: {
      closeButton: 'modal__close-icon'
    },
    confirmButtonText: '確認',
    cancelButtonText: '取消',
    ...config
  } as SweetAlertOptions);
};

export default {
  info,
  success,
  error,
  confirm,
  modal
};
